import { ICalculatorWidgetEventMap } from './types';

export function dispatchWidgetEvent<EventName extends keyof ICalculatorWidgetEventMap>(
  eventTarget: EventTarget,
  eventName: EventName,
  detail: ICalculatorWidgetEventMap[EventName],
): void {
  eventTarget.dispatchEvent(
    new CustomEvent<ICalculatorWidgetEventMap[EventName]>(eventName, { detail, bubbles: true, cancelable: false }),
  );
}
